const api_end_point = "https://tcagenda2023.s.cmshelp.dk/agendaList/";
//const api_end_point = "https://conferenceapiagenda.s.cmshelp.dk/AgendaList/";
//const api_end_point = "https://localhost:44352/AgendaList/";
export default {
    api_end_point: api_end_point,
    initial_load_api: api_end_point + "GetAllAgendaSpeakersApiDataAll?eventName=emf",
    //category_list_api: api_end_point + "GetAllAgendaSpeakersDataAll?eventName=fea",
    date_list_api: api_end_point + "GetDateList",
    agenda_detail_api: api_end_point + "GetAgendaDataById",
    user_detail_api: api_end_point + "GetSpeakersByUserIdAll",

    category_list_api: (eventname,type) => `${api_end_point}GetAllAgendaSpeakersApiDataAll?eventName=${eventname}&type=${type}`,
};


